import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HelperService, MealPlanService, OrganizationService, UserService } from 'src/app/services';
import { IMeal, Organization, User,} from 'src/app/models';

@Component({
  selector: 'app-meal-select',
  templateUrl: './meal-select.page.html',
  styleUrls: ['./meal-select.page.scss'],
})
export class MealSelectPage implements OnInit {

  public activeOrganization: Organization;
  public activeUser: User;
  public meals: IMeal[] = [];
  public searchTerm = "";

  constructor(
    private modalCtrl: ModalController,
    private organizationService: OrganizationService,
    private mealPlanService: MealPlanService,
    private helperService: HelperService,
    private userService: UserService,
  ) { 
    this.activeUser = this.userService.getAppUser();
    this.activeOrganization = this.organizationService.getAppOrganization();
  }

  async ngOnInit() {
    this.loadMeals();
  }

  async loadMeals() {
    let meals;
    if(this.activeOrganization?.isUserTrainer(this.activeUser.uid)) {
      meals = await this.mealPlanService.getMealsAsPromiseByOrganization(this.activeOrganization.uid);
    } else {
      meals = await this.mealPlanService.getMealsAsPromiseByUser(this.activeUser.uid);
    }
    this.meals.push(...meals);
  }

  getFilteredMeals() {
    let filteredMeals = [];
    for (const meal of this.meals) {
      if(!this.searchTerm) {
        filteredMeals.push(meal);
      } else {
        if(meal.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1) {
          filteredMeals.push(meal);
        }
      }
    }
    return filteredMeals.sort((a,b) => {
      return a.title.localeCompare(b.title);
    });
  }

  selectMeal(meal) {
    this.modalCtrl.dismiss({ status: "selected", data: this.helperService.copyObject(meal) });
  }

  cancel() {
    this.modalCtrl.dismiss({ status: "canceled" });
  }

}
